import { NavLink, useMatch } from 'react-router-dom'
import { useAuth, isClientAdmin, isAdmin } from '../../context/AuthContext'
import styles from './SiteHeader.module.css'

interface Props {
  subtitle?: string
}

const ROLE_LABELS: Record<string, string> = {
  clutch_admin:      'Admin',
  clutch_consultant: 'Consultant',
  client_admin:      'Client View',
}

export function SiteHeader({ subtitle = 'OCM Assessment Suite' }: Props) {
  const { user, platformUser, signOut } = useAuth()
  const onAssessment = useMatch('/r/:token')
  const onLogin      = useMatch('/login')

  // Hide the full nav on respondent and login pages
  const hideNav = Boolean(onAssessment || onLogin)

  return (
    <header className={styles.header}>
      <div className={styles.logoMark}>
        <img src="/clutch-logo.jpg" alt="Clutch" className={styles.logoIcon} />
      </div>
      <div className={styles.sep} />
      <span className={styles.sub}>{subtitle}</span>

      {!hideNav && user && (
        <nav className={styles.nav} aria-label="Main navigation">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
            }
          >
            Dashboard
          </NavLink>

          {/* Analytics hidden from Client Admin — they see aggregate only */}
          {!isClientAdmin(platformUser) && (
            <NavLink
              to="/analytics"
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
            >
              Analytics
            </NavLink>
          )}

          {/* Diagnostic + Setup — Clutch staff only */}
          {!isClientAdmin(platformUser) && (
            <>
              <NavLink
                to="/diagnostic"
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                }
              >
                Diagnostic
              </NavLink>
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                }
              >
                Setup
              </NavLink>
            </>
          )}

          {/* Users — clutch_admin only */}
          {isAdmin(platformUser) && (
            <NavLink
              to="/setup"
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
              }
            >
              Users
            </NavLink>
          )}
        </nav>
      )}

      <div className={styles.right}>
        {user && platformUser ? (
          <div className={styles.userMenu}>
            {/* Role badge */}
            <span
              className={`${styles.roleBadge} ${
                isClientAdmin(platformUser) ? styles.roleBadgeClient : styles.roleBadgeClutch
              }`}
            >
              {ROLE_LABELS[platformUser.role] ?? platformUser.role}
            </span>

            {/* User email (truncated) */}
            <span className={styles.userEmail} title={user.email ?? undefined}>
              {user.email}
            </span>

            <button className={styles.signOutBtn} onClick={() => signOut()} type="button">
              Sign out
            </button>
          </div>
        ) : !hideNav ? (
          <span className={styles.poweredBy}>
            Powered by <strong>Mosaic Data Solutions</strong>
          </span>
        ) : null}
      </div>
    </header>
  )
}
